export enum PolicyVersionState {
  Wait4Sign = 1,
  Ongoing = 2,
  Na = 3,
  Replaced = 4,
  Sent = 5
}
